import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import authentication from "../middleware/authentication"
import permissionCheckAdmin from "../middleware/permissionCheckAdmin.js"
import permissionCheckSale from "../middleware/permissionCheckSale.js"
import permissionCheckStore from "../middleware/permissionCheckStore.js"

const routes = [
	{
		path: '/',
		name: 'home',
		component: HomeView
	},
	{
		path: '/login',
		name: 'login',
		component: () => import('../views/Login.vue')
	},
	{
		path: '/register',
		name: 'register',
		component: () => import('../views/Register.vue')
	},
	{
		path: '/forgot-password',
		name: 'forgot-password',
		component: () => import('../views/ForgotPassword.vue')
	},
	{
		path: '/admin',
		name: 'admin',
		meta: {
			middleware: [authentication, permissionCheckAdmin],
		},
		component: () => import('../views/Admin.vue'),
		redirect: {
			name: 'admin-default'
		},
		children: [
			{ path: '', name: 'admin-default', component: () => import('../views/AdminDefault.vue') },
			{ path: 'notify', name: 'admin-notify', component: () => import('../views/AdminNotify.vue') },
			{ path: 'daily-log', name: 'admin-daily-log', component: () => import('../views/AdminDailyLog.vue') },
			{ path: 'email-log', name: 'admin-email-log', component: () => import('../views/AdminEmailLog.vue') },
			{ path: 'new-registation-list', name: 'admin-new-registation-list', component: () => import('../views/AdminNewRegister.vue') },
			{ path: 'all-user', name: 'admin-all-user', component: () => import('../views/AdminAllUserList.vue') },
			{ path: 'admin-manage', name: 'admin-manage', component: () => import('../views/AdminManage.vue') },
			{ path: 'rejected-list', name: 'admin-rejected-list', component: () => import('../views/AdminRejectedList.vue') },
		],
	},
	{
		path: '/mycustomer',
		name: 'mycustomer',
		meta: {
			middleware: [authentication, permissionCheckSale]
		},
		component: () => import('../views/LoggedPage.vue'),
		redirect: {
			name: 'sale-default'
		},
		children: [
			{ path: '', name: 'sale-default', component: () => import('../views/SalePage.vue') },
			{ path: 'store-detail/:storeId', name: 'sale-store-detail', component: () => import('../views/SalePageStoreDetail.vue') },
		],
	},
	{
		path: '/mystore',
		name: 'mystore',
		meta: {
			middleware: [authentication, permissionCheckStore],
		},
		component: () => import('../views/LoggedPage.vue'),
		redirect: {
			name: 'store-default'
		},
		children: [
			{ path: '', name: 'store-default', component: () => import('../views/StorePage.vue') },
		],
	},
	{
		path: '/SO',
		name: 'sopage',
		component: () => import('../views/SOPage.vue')
	},
	{
		path: '/SO/:sonumber?',
		name: 'sopage',
		component: () => import('../views/SOPage.vue')
	},
	{
		path: '/SOPAGE/:sonumber',
		name: 'sopage2',
		component: () => import('../views/SOPage2.vue')
	},
	{
		path: '/PO_search',
		name: 'popage_soldto',
		meta: {
			// middleware: [authentication],
		},
		component: () => import('../views/POPage.vue')
	},
	{
		path: '/SO_DATE_PAGE',
		name: 'SO_DATE_PAGE',
		meta: {
			middleware: [authentication],
		},
		component: () => import('../views/SO_DATE_PAGE.vue')
	},
	{
		path: '/PO_DATE_PAGE',
		name: 'PO_DATE_PAGE',
		meta: {
			middleware: [authentication],
		},
		component: () => import('../views/PO_DATE_PAGE.vue')
	},
	{
		path: '/PO_search/:ponumber',
		name: 'popage',
		component: () => import('../views/POPage.vue')
	},
	{
		path: '/PO_search',
		name: 'popage',
		component: () => import('../views/POPage.vue')
	},
	// {
	// 	path: '/myso/:soldTo',
	// 	name: 'myso',
	// 	component: () => import('../views/MySo.vue')
	// },

	{
		path: "/:pathMatch(.*)*",
		name: "not-found",
		component: () => import('../views/PageNotFound.vue')
	},
	{
		path: '/images/:billNumber',
		name: 'ImagePage',
		component: () => import('../views/ImagePage.vue'),
		props: route => ({
			billNumber: route.params.billNumber
		})
	},
	{
		path: '/myso/:soldTo',
		name: 'myso',
		component: () => import('../views/EorStorePage.vue')
	},

	{
		path: '/SOeor/:sonumber?',
		name: 'soeorpage',
		component: () => import('../views/SOeorPage.vue')
	},
]

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
	scrollBehavior(to, from, savedPosition) {
		// return desired position
		// return { top: 0 }
	}
})

export default router
